import styled from 'styled-components'

export const Container = styled.div`
    padding: 20px;
`

export const Back = styled.button`
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    border-radius: 50%;
    padding: 4px;
    cursor: pointer;
    transition: background 0.2s;
    &:hover {
        background: rgba(0, 157, 221, 0.1);
    }
`
export const LinkData = styled.div`
    margin-top: 30px;
    background: #fff;
    border-radius: 10px;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    padding: 10px;
    h3 {
        font-family: 'Roboto', sans-serif;
        font-weight: 600;
        font-size: 21px;
        margin-bottom: 8px;
    }

    h4 {
        font-family: 'Roboto', sans-serif;
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 5px;
    }

    .input-group {
        padding: 10px 0;
    }

    .input-group:not(:last-child) {
        border-bottom: 1px solid #d3d3d3;
    }

    .receiver {
        margin-bottom: 10px;
    }

    .wrapper {
        margin-bottom: 5px;

        p {
            font-family: 'Inter', sans-serif;
            font-size: 17px;
        }

        p + p {
            margin-top: 6px;
        }

        .situation {
            font-size: 18px;
        }

        .op,
        .canal {
            font-size: 15px;
        }
    }

    .details {
        p {
            font-size: 15px;
        }
    }
    .flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
`

export const LinkContracts = styled.div`
    /* padding: 0 10px; */
    margin-top: 30px;
    border-radius: 10px;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    margin-bottom: 40px;
    overflow: auto;
`
export const Header = styled.div`
    padding: 15px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 1000px;

    .title {
        h2 {
            font-family: 'Roboto';
            font-weight: 500;
            font-size: 20px;
        }
    }

    .exports {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    button {
        display: flex;
        align-items: center;
        gap: 4px;
        font-family: 'Poppins';
        font-weight: 500;
        color: #3c363b;
        border: 1px solid #d3d3d3;
        padding: 4px 6px;
        border-radius: 8px;
        cursor: pointer;

        svg {
            color: #6d756a;
        }
    }
`

export const ContractsTable = styled.table`
    padding: 10px;
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    min-width: 1000px;
    thead {
        padding: 0 10px;
        border-bottom: 1px solid #d3d3d3;
        border-top: 1px solid #d3d3d3;

        th {
            color: #a8a39d;
            font-weight: 400;
            font-family: 'Poppins';
            font-size: 14px;
            padding: 10px 0;
            height: 63px;
            /* width: min-content; */
        }

        th:first-child {
            width: 50px;
            padding: 0 10px;
        }
        /* 
    th.valor {
      width: 10%;
    } */

        /* th:last-child {
      width: 40px;
    }  */

        th.tipo {
            width: 80px;
        }

        th.categoria {
            width: 30px;
        }

        th.adq {
            width: 166px;
        }

        th.valor {
        }

        th.recebedor {
            width: 128px;
        }
    }

    tbody {
        tr:not(tr:last-child) {
            border-bottom: 1px solid #d3d3d3;
        }

        tr > td {
            /* color: #333;
      font-family: 'Inter';
      font-weight: 400; */
            &.negative {
                /* color: red; */
            }
            /* width: max-content; */
        }
        td:first-child {
            width: 50px;
            padding: 0 10px;
        }

        td:nth-child(7) {
            width: 120px;
        }

        tr {
            cursor: pointer;

            &:hover {
                background: rgba(0, 157, 221, 0.1);
            }
        }

        .arrow {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #d3d3d3;
            background: #fff;
            border-radius: 8px;
            padding: 4px;
            transition: transform 0.2s ease-in;
            transform: rotate(180deg);
            cursor: pointer;
        }
        .arrow.down {
            svg {
                transform: rotate(180deg);
            }
        }
    }

    td,
    th {
        padding: 15px 0;
        text-align: left;
    }

    .order {
        display: inline-flex;
        align-items: center;
        gap: 3px;
        transform: rotate(0deg);
        transition: transform 0.2s ease-in;
        cursor: pointer;
    }

    .order.desc {
        svg {
            transform: rotate(180deg);
        }
    }

    tfoot {
        border-top: 1px solid #d3d3d3;
        font-family: 'Inter';
        font-weight: 400;
    }
    /* 
  .valorLivre {
    display: flex;
    align-items: center;
    gap: 3px;
    transform: rotate(0deg);
    transition: transform .2s ease-in;
    cursor: pointer;
  } */

    /* .valorLivre.desc {
    svg {
      transform: rotate(180deg);
    }
  } */
    /* 
  .checkbox {
    width: 16px;
    height: 16px;
    cursor: pointer;
  } */

    /* td.edit {
    width: 10%;
   > span {
     white-space: nowrap;
     padding: 3px 5px;
     border: 1px solid #D3D3D3;
     border-radius: 6px;
     font-size: 13px;
     font-weight: 500;
     cursor: pointer;
      &:hover {
        color: #566583;
      }
   }
  } */
`

export const Recurrence = styled.div`
    margin: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 10px;

    a {
        color: #4c83ee;

        &:hover {
            color: #566583;
        }
    }
    /* justify-content: flex-end; */
`
